import "./ProductContainer.css"
import {PickProgramPageHelper} from "../../Utilities/CmsHelpers";
import React from "react";

export default function ProductContainer({product, pickAddons}) {
    const cmsData = PickProgramPageHelper.getAddon(pickAddons, product?.skuORQuickCode)[0]

    if(!cmsData) return <></>
    return (<>
        <div className={"pickaddon-addon-wraper"}>
            <div className={"pickaddon-content-container"}>
                <div className={"pickaddon-content-wrapper"}>
                    <img src={cmsData?.icon?.url} alt={`${product.skuORQuickCode} icon`}/>
                    <div>
                        <span className={"title"}>{cmsData?.title}</span>
                        <span className={"subtitle"}>{cmsData?.description}</span>
                    </div>
                </div>
                <div className={"pickaddon-price-wrapper"}>
                    {(cmsData?.oldPriceAfterPrice ||
                            cmsData?.oldPriceBeforePrice ||
                            cmsData?.oldPricePrice) &&
                        <div className={"pickaddon-old-price"}>
                            {!!cmsData?.oldPriceBeforePrice &&
                                <span className={"pickaddon-old-price-before"}>{cmsData?.oldPriceBeforePrice}</span>
                            }
                            {!!cmsData?.oldPricePrice &&
                                <>
                                    <span className={"pickaddon-old-price-price"}>{cmsData?.oldPricePrice}</span>
                                    <div className={"crossed-line"} />
                                </>
                            }
                            {!!cmsData?.oldPriceAfterPrice &&
                                <span className={"pickaddon-old-price-after"}>{cmsData?.oldPriceAfterPrice}</span>
                            }
                        </div>
                    }
                    <div className={"pickaddon-current-price-wrapper"}>
                        <span className={"before-price"}>{cmsData?.beforePrice}</span><span className={"after-price"}>{cmsData?.afterPrice}</span>
                    </div>
                </div>
            </div>
            <span className={"pickaddon-disclaimer"}>
                {cmsData?.disclaimer}
            </span>
        </div>
    </>)
}